const DB_NAME = "paws";
const STORE = "history";
const MAX_ITEMS = 100;

function promisify(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export class HistoryStore {
  constructor(indexedDb = globalThis.indexedDB) {
    this.indexedDb = indexedDb;
    this.dbPromise = null;
  }

  open() {
    if (!this.indexedDb) return Promise.reject(new Error("IndexedDB non disponibile"));
    this.dbPromise ||= new Promise((resolve, reject) => {
      const request = this.indexedDb.open(DB_NAME, 1);
      request.onupgradeneeded = () => {
        const store = request.result.createObjectStore(STORE, { keyPath: "id" });
        store.createIndex("createdAt", "createdAt");
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
    return this.dbPromise;
  }

  async #tx(mode) {
    const db = await this.open();
    return db.transaction(STORE, mode).objectStore(STORE);
  }

  async add(entry) {
    const item = { id: entry.id || crypto.randomUUID(), createdAt: entry.createdAt || Date.now(), ...entry };
    await promisify((await this.#tx("readwrite")).put(item));
    await this.prune();
    return item;
  }

  async list() {
    const items = await promisify((await this.#tx("readonly")).getAll());
    return items.sort((a, b) => b.createdAt - a.createdAt);
  }

  async update(id, patch) {
    const store = await this.#tx("readwrite");
    const current = await promisify(store.get(id));
    if (!current) return null;
    const next = { ...current, ...patch };
    await promisify(store.put(next));
    return next;
  }

  async remove(id) {
    await promisify((await this.#tx("readwrite")).delete(id));
  }

  async clear() {
    await promisify((await this.#tx("readwrite")).clear());
  }

  async prune() {
    const items = await this.list();
    const excess = items.slice(MAX_ITEMS);
    if (!excess.length) return;
    const store = await this.#tx("readwrite");
    await Promise.all(excess.map((item) => promisify(store.delete(item.id))));
  }
}
